import React, { createContext, useContext, useMemo } from "react";
import { SnackbarProviderProps, SnackbarProvider } from "notistack";

interface SnackbarProviderContextType {
  snackbarProps: SnackbarProviderProps;
}

const SnackbarProviderWrapperContext =
  createContext<SnackbarProviderContextType | null>(null);

declare module "notistack" {
  interface VariantOverrides {
    exportReportSnackbar: true;
  }
}

export const useSnackbarProviderWrapper = () => {
  const context = useContext(SnackbarProviderWrapperContext);
  if (!context) {
    throw new Error(
      "useSnackbarProviderWrapper must be used within a SnackbarProviderWrapper",
    );
  }
  return context.snackbarProps;
};

interface SnackbarProviderWrapperProps extends SnackbarProviderProps {
  children: React.ReactNode;
}

export const SnackbarProviderWrapper: React.FC<
  SnackbarProviderWrapperProps
> = ({ children, ...props }) => {
  const contextValue = useMemo(() => ({ snackbarProps: props }), [props]);

  return (
    <SnackbarProviderWrapperContext.Provider value={contextValue}>
      <SnackbarProvider {...props}>{children}</SnackbarProvider>
    </SnackbarProviderWrapperContext.Provider>
  );
};

//////////////////////////////////////

// import React, { createContext, useContext } from "react";
// import { SnackbarProvider, SnackbarProviderProps } from "notistack";
// import { SnackbarConfig, defaultSnackbarConfig } from "./snackbarConfig";

// interface SnackbarContextType {
//   snackbarConfig: SnackbarConfig;
// }

// const SnackbarContext = createContext<SnackbarContextType>({
//   snackbarConfig: defaultSnackbarConfig,
// });

// export const useSnackbarContext = () => useContext(SnackbarContext);

// interface SnackbarProviderWrapperProps extends SnackbarProviderProps {
//   snackbarConfig?: SnackbarConfig;
// }

// declare module "notistack" {
//   interface VariantOverrides {
//     exportReportSnackbar: true;
//   }
// }

// export const SnackbarProviderWrapper: React.FC<
//   SnackbarProviderWrapperProps
// > = ({ snackbarConfig = defaultSnackbarConfig, children, ...other }) => {
//   const { maxSnack, autoHideDuration, exportReportSnackbar, ...rest } =
//     snackbarConfig;
//   return (
//     <SnackbarContext.Provider value={{ snackbarConfig }}>
//       <SnackbarProvider
//         maxSnack={maxSnack}
//         autoHideDuration={autoHideDuration}
//         Components={{ exportReportSnackbar: exportReportSnackbar }}
//         {...rest}
//         {...other}
//       >
//         {children}
//       </SnackbarProvider>
//     </SnackbarContext.Provider>
//   );
// };
